<!-- <div
  class="layout-header"
  style="border-bottom: 50px solid #252525; border-top: 5px solid #252525"
>

  <strong class="header-ci"
    ><a [routerLink]="['dashboard']"
      ><img
        src="../../../../../assets/images/logos/login_lg_logo.png"
        height="33.5"
        width="150"
        alt="LG Water Solutions,LG Chem" /></a
  ></strong>
  <div class="header-gnb-wrap" style="font-family: Calibri">
    <ul class="header-gnb">
      <li>
        <a [routerLink]="['/dashboard']" name="depth1Main">Dashboard</a>
      </li>
      <li
        name="depth1"
        [class.is-view]="opdata"
        [class.is-active]="opdata"
      >
        <a
          name="depth1Main"
          (mouseover)="onMouseOveropdata()"
          (mouseout)="onMouseOutopdata()"
          >Operation Data</a
        >
        <ul>
          <li>
            <a [routerLink]="['/opdata']">Manage</a>
          </li>
          <li>
            <a >Import</a>
          </li>
          <li>
            <a >Add</a>
          </li>
        </ul>
      </li>
      <li
        [class.is-view]="eventlogs"
        [class.is-active]="eventlogs"
      >
        <a
          
          (mouseover)="onMouseOvereventlogs()"
          (mouseout)="onMouseOuteventlogs()"
          >Event Logs</a
        >
        <ul>
          <li>
            <a>Add</a>
          </li>
          <li>
            <a>Manage</a>
          </li>
        </ul>
      </li>
      <li
        name="depth1"
        [class.is-view]="conductivityprofiles"
        [class.is-active]="conductivityprofiles"
      >
        <a
          name="depth1Main"
          (mouseover)="onMouseOverconductivityprofiles()"
          (mouseout)="onMouseOutconductivityprofiles()"
          >Conductivity Profiles</a
        >
        <ul>
          <li>
            <a>Manage</a>
          </li>
          <li>
            <a>Import</a>
          </li>
          <li>
            <a>Add</a>
          </li>
        </ul>
      </li>
      <li name="depth1" [class.is-view]="graphs" [class.is-active]="graphs">
        <a
          name="depth1Main"
          (mouseover)="onMouseOvergraphs()"
          (mouseout)="onMouseOutgraphs()"
          >Graphs</a
        >
        <ul>
          <li>
            <a>Primary</a>
          </li>
          <li>
            <a>Custom</a>
          </li>
          <li>
            <a>Comparison</a>
          </li>
          <li>
            <a>Conductivity Profile</a>
          </li>
        </ul>
      </li>

      <li name="depth1" [class.is-view]="projects" [class.is-active]="projects">
        <a
          name="depth1Main"
          (mouseover)="onMouseOverprojects()"
          (mouseout)="onMouseOutprojects()"
          >Projects</a
        >
        <ul>
          <li>
            <a [routerLink]="['/plants']">Plants</a>
          </li>
          <li>
            <a [routerLink]="['/
          </li>
          <li>
            <a>Import Map</a>
          </li>
          <li>
            <a [routerLink]="['/warrantycondition']">Warranties</a>
          </li>
          <li>
            <a>Load</a>
          </li>
        </ul>
      </li>
      <li
        name="depth1"
        [class.is-view]="admin"
        [class.is-active]="admin"
        *ngIf="Role === 'Admin'"
      >
        <a (mouseover)="onMouseOveradmin()" (mouseout)="onMouseOutadmin()"
          >Admin</a
        >
        <ul>
          <li>
            <a [routerLink]="['/user']">User</a>

          </li>
          <li>
            <a [routerLink]="['/companies']">Company</a>
          </li>
          <li>
            <a [routerLink]="['/models']">Element Model</a>
          </li>
          <li>
            <a [routerLink]="['/manufacturers']"
              >Element Manufacturer</a
            >
          </li>
        </ul>
      </li>

      <li
        name="depth1"
        [class.is-view]="accounts"
        [class.is-active]="accounts"
        *ngIf="Role === 'Internal User'"
      >
        <a (mouseover)="onMouseOveraccounts()" (mouseout)="onMouseOutaccounts()"
          >Accounts</a
        >
        <ul>
          <li>
            <a>Add User</a>
          </li>
          <li>
            <a>Add Company</a>
          </li>
        </ul>
      </li>
      <li *ngIf="Role === 'Admin'" name="depth1" [class.is-active]="restore">
        <a
          name="depth1Main"
          (mouseover)="onMouseOverRestore()"
          (mouseout)="onMouseOutRestore()"
          >Restore</a
        >
      </li>

    </ul>
    
  </div>
  <strong class="header-user" style="text-align: left">
    <li class="nav-item" ngbDropdown placement="bottom-end">
      <a
        ngbDropdownToggle
        class="nav-link waves-effect waves-dark pro-pic"
        href="javascript:void(0)"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img
          src="assets/images/users/user1.jpg"
          alt="user"
          class="rounded-circle"
          width="31"
        />
        <span class="ms-2">{{ firstName }}</span>
      </a>
      <div class="dropdown-menu-right" ngbDropdownMenu>
        <a class="dropdown-item p-2" (click)="logout()"> Logout</a>
      </div>
    </li>
  </strong>
</div> -->

<!-- <div class="navbar">
  <strong class="header-ci"
    ><a [routerLink]="['dashboard']"
      ><img
        src="../../../../../assets/images/logos/login_lg_logo.png"
        height="33.5"
        width="150"
        alt="LG Water Solutions,LG Chem" /></a
  ></strong>

  <a [routerLink]="['dashboard']">Dashboard</a>

  <div class="subnav">
    <button class="subnavbtn">Operation Data</button>
    <div class="subnav-content" style="padding-left: 330px">
      <a [routerLink]="['/opdata']">Manage</a>
      <a [routerLink]="['/opdata/import']">Import</a>
      <a [routerLink]="['/opdata/opdata-add']">Add</a>
    </div>
  </div>

  <div class="subnav">
    <button class="subnavbtn">Event Logs</button>
    <div class="subnav-content" style="padding-left: 520px">
      <a [routerLink]="['/eventlogs/add-eventlogs']">Add</a>
      <a [routerLink]="['/eventlogs']">Manage</a>
    </div>
  </div>

  <div class="subnav">
    <button class="subnavbtn">Conductivity Profiles</button>
    <div class="subnav-content" style="padding-left: 670px">
      <a [routerLink]="['/conductivityprofile']">Manage</a>
      <a [routerLink]="['/conductivityprofile/import-conductivityprofile']"
        >Import</a
      >
      <a [routerLink]="['/conductivityprofile/add-conductivityprofile']">Add</a>
    </div>
  </div>

  <div class="subnav">
    <button class="subnavbtn">Graphs</button>
    <div class="subnav-content" style="padding-left: 715px">
      <a [routerLink]="['graph/primarygraph']">Primary</a>
      <a [routerLink]="['/graph/customgraph']">Custom</a>
      <a [routerLink]="['/graph/comparisongraph']">Comparison</a>
      <a [routerLink]="['/graph/conductivityprofilegraph']"
        >Conductivity Profile</a
      >
    </div>
  </div>

  <div class="subnav">
    <button class="subnavbtn">Projects</button>
    <div class="subnav-content" style="padding-left: 850px">
      <a [routerLink]="['/plants']">Plants</a>
      <a [routerLink]="['/trains']">Trains</a>
      <a [routerLink]="['/importmaps']">Import Map</a>
      <a [routerLink]="['/warrantycondition']">Warranties</a>
     
    </div>
  </div>

  <div class="subnav" *ngIf="Role === 'Admin'">
    <button class="subnavbtn">Admin</button>
    <div class="subnav-content" style="padding-left: 900px">
      <a [routerLink]="['/user']">User</a>
      <a [routerLink]="['/companies']">Company</a>
      <a [routerLink]="['/models']">Element Model</a>
      <a [routerLink]="['/manufacturers']">Element Manufacturer</a>
    </div>
  </div>

  <div class="subnav" *ngIf="Role === 'Internal User'">
    <button class="subnavbtn">Accounts</button>
    <div class="subnav-content" style="padding-left: 1205px">
      <a [routerLink]="['/user/user-add']">Add User</a>
      <a [routerLink]="['/companies/company-add']">Add Company</a>
    </div>
  </div>
  <ul>
    <div class="subnav">
      <div class="user-container">
        <a>
          <img
            src="assets/images/users/user1.jpg"
            alt="user"
            class="rounded-circle"
            width="31"
          />
        </a>

        <li class="mr-5">
          <a>{{ firstName }}</a>
          <ul class="dropdown">
            <li><a (click)="logout()">Logout</a></li>
          </ul>
        </li>
      </div>

      <div class="subnav-content" style="padding-left: 1205px">
        <a [routerLink]="['profile', loggedInUserId]">Profile</a>
      </div>
    </div>
  </ul>
</div> -->


 
<div class="navbar">
 
  <div class="logo">
    <a [routerLink]="['dashboard']">
      <img
        src="../../../../../assets/images/logos/NanoH2O-Black@3x 1.png"
        height="30"
        width="350"
        alt="LG Water Solutions, LG Chem"
      />
    </a>
  </div>
 
 
  <ul class="nav-links">
    <!-- <li><a [routerLink]="['dashboard']">Dashboard</a></li> -->
  <li><a (click)="goToDashboard()">Dashboard</a></li>

    <li class="dropdown">
      <a href="javascript:void(0)" class="dropbtn">Operation Data</a>
      <div class="main-dropdown-content">
        <div class="dropdown-content">
          <a routerLink="/opdata" (click)="setMenu('Operation Data','Manage Operation Data')">Manage</a>
          <a routerLink="/opdata/import" (click)="setMenu('Operation Data' ,'Import Operation Data')">Import</a>
          <a routerLink="/opdata/opdata-add" (click)="setMenu('Operation Data','Add Operation Data')">Add</a>

          <!-- <a [routerLink]="['/opdata']">Manage</a>
          <a [routerLink]="['/opdata/import']">Import</a>
          <a [routerLink]="['/opdata/opdata-add']">Add</a> -->
        </div>
      </div>
    </li>
 
    <li class="dropdown">
      <a href="javascript:void(0)" class="dropbtn">Event Logs</a>
      <div class="main-dropdown-content">
        <div class="dropdown-content">
          <a routerLink="/eventlogs" (click)="setMenu('Event Logs','Manage Event Logs')">Manage</a>
          <a routerLink="/eventlogs/add-eventlogs" (click)="setMenu('Event Logs','Add Event Logs')">Add</a>
          <!-- <a [routerLink]="['/eventlogs/add-eventlogs']">Add</a>
          <a [routerLink]="['/eventlogs']">Manage</a> -->
        </div>
      </div>
    </li>
 
 
    <li class="dropdown">
      <a href="javascript:void(0)" class="dropbtn">Conductivity Profiles</a>
      <div class="main-dropdown-content">
        <div class="dropdown-content">
          <a routerLink="/conductivityprofile" (click)="setMenu('Conductivity Profile','Manage Conductivity Profile')">Manage</a>
          <a routerLink="/conductivityprofile/import-conductivityprofile" (click)="setMenu('Conductivity Profile','Import Conductivity Profile')">Import</a>
          <a routerLink="/conductivityprofile/add-conductivityprofile" (click)="setMenu('Conductivity Profile','Add Conductivity Profile')">Add</a>
                            
          <!-- <a [routerLink]="['/conductivityprofile']">Manage</a>
          <a [routerLink]="['/conductivityprofile/import-conductivityprofile']"
            >Import</a
          >
          <a [routerLink]="['/conductivityprofile/add-conductivityprofile']"
            >Add</a
          > -->
        </div>
      </div>
    </li>
 
 
    <li class="dropdown">
      <a href="javascript:void(0)" class="dropbtn">Graphs</a>
      <div class="main-dropdown-content">
        <div class="dropdown-content">
          <!-- <a [routerLink]="['graph/primarygraph']">Primary</a>
          <a [routerLink]="['/graph/customgraph']">Custom</a>
          <a [routerLink]="['/graph/comparisongraph']">Comparison</a>
          <a [routerLink]="['/graph/conductivityprofilegraph']"
            >Conductivity Profile</a
          > -->

          <a routerLink="/graph/primarygraph" (click)="setMenu('Graphs','Primary Graph')">Primary</a>
          <a routerLink="/graph/customgraph" (click)="setMenu('Graphs','Custom Graph')">Custom</a>
          <a routerLink="/graph/comparisongraph" (click)="setMenu('Graphs','Comparison Graph')">Comparison</a>
          
          <a routerLink="/graph/conductivityprofilegraph" (click)="setMenu('Graphs','Conductivity Profile Graph')">Conductivity
            Profile</a>

        </div>
      </div>
    </li>
 
 
    <li class="dropdown">
      <a href="javascript:void(0)" class="dropbtn">Projects</a>
      <div class="main-dropdown-content">
        <div class="dropdown-content">
          <a routerLink="/plants" (click)="setMenu('Projects','Plants')">Plants</a>
          <a routerLink="/trains" (click)="setMenu('Projects','Trains')">Trains</a>
          <a routerLink="/importmaps" (click)="setMenu('Projects','Import Map')">Import Map</a>
          <a routerLink="/warrantycondition" (click)="setMenu('Projects','Warranty Condition')">Warranties</a>

          <!-- <a [routerLink]="['/plants']">Plants</a>
          <a [routerLink]="['/trains']">Trains</a>
          <a [routerLink]="['/importmaps']">Import Map</a>
          <a [routerLink]="['/warrantycondition']">Warranties</a> -->
        </div>
      </div>
    </li>
 
 
    <li class="dropdown" *ngIf="Role === 'Admin'">
      <a href="javascript:void(0)" class="dropbtn">Admin</a>
      <div class="main-dropdown-content">
        <div class="dropdown-content">
          <a [routerLink]="['/user']">User</a>
          <a [routerLink]="['/companies']">Company</a>
          <a [routerLink]="['/models']">Element Model</a>
          <a [routerLink]="['/manufacturers']">Element Manufacturer</a>
        </div>
      </div>
    </li>
 
 
    <li class="dropdown" *ngIf="Role === 'Internal User'">
      <a href="javascript:void(0)" class="dropbtn">Accounts</a>
      <div class="main-dropdown-content">
        <div class="dropdown-content">
          <a [routerLink]="['/user/user-add']">Add User</a>
          <a [routerLink]="['/companies/company-add']">Add Company</a>
        </div>
      </div>
    </li>
  </ul>
 
 
  <div class="user-menu">
    <img
      src="assets/images/users/user1.jpg"
      alt="user"
      class="rounded-circle"
      width="31"
    />
    <div style="font-weight : bold">{{ firstName }}</div>
    <div class="dropdown-content">
      <a [routerLink]="['profile', loggedInUserId]">Profile</a>
      <a (click)="logout()">Logout</a>
    </div>
  </div>
</div>
 
 